import { render, staticRenderFns } from "./TheTeamInstructionsOutOfPossession.vue?vue&type=template&id=20b873f4&scoped=true"
import script from "./TheTeamInstructionsOutOfPossession.vue?vue&type=script&lang=js"
export * from "./TheTeamInstructionsOutOfPossession.vue?vue&type=script&lang=js"
import style0 from "./TheTeamInstructionsOutOfPossession.vue?vue&type=style&index=0&id=20b873f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@7.0.0-bridge.0_@babel+core@7.26.7__cac_fzj6xqfhz2iur5pptcdfbzd24y/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b873f4",
  null
  
)

export default component.exports